<template>
  <div>
    <div v-if="startDrug" class="text-center">
        Мінімальна відстань: <b>{{minDistance.toFixed(2)}}</b>км.
    </div>
    <div class="col-md-12 text-center">
      <gmap-map ref="map" :options="{ disableDefaultUI: false }" @click="drug" :center="computedCenter" :zoom="zoom" style="width: 100%; min-height: 400px">
        <gmap-marker v-if="startDrug" :clickable="true" :draggable="true" @drag="drug" :position="location_from">
        </gmap-marker>
        <gmap-marker :position="getCoordinates()"/>
      </gmap-map>
      <v-btn v-if="startDrug" color="primary" class="ma-1" small @click="getDirection()">Прокласти маршрут</v-btn>
      <v-alert v-else dense type="success">Щоб розпочати прокладати маршрут поставте другий маркер на карті</v-alert>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MapWayToPoint',
  props: {
    location: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      startDrug: false,
      location_from: {
        lat: 48.87117501979988,
        lng: 24.70347745165164
      },
      center: {
        lat: 48.87117501979988,
        lng: 24.70347745165164
      },
      zoom: 8
    };
  },
  computed: {
    minDistance () {
      return this.calcDistance(this.location_from, this.getCoordinates());
    },
    computedCenter () {
      return this.getCenter(this.location_from, this.getCoordinates());
    }
  },
  created () {
    this.center = this.getCoordinates();
    this.location_from = this.getCoordinates();
  },
  mounted () {
    this.zoom = this.getZoom();
  },
  methods: {
    drug (location) {
      this.startDrug = true;
      this.location_from = { lat: location.latLng.lat(), lng: location.latLng.lng() };
    },
    getZoom () {
      let distance = this.minDistance;
      if (distance <= 10) return 12;
      if (distance <= 50) return 10;
      if (distance <= 100) return 8;
      if (distance <= 200) return 7;
      if (distance <= 500) return 6;
      if (distance <= 900) return 5;
      return 2;
    },
    getCenter (from, to) {
      if (from && to) {
        return {
          lat: (from.lat + to.lat) / 2,
          lng: (from.lng + to.lng) / 2
        };
      } else {
        return this.location;
      }
    },
    getCoordinates () {
      const item = this.location;
      if (!item) {
        return undefined;
      }
      return { lat: item['latitude'], lng: item['longitude'] };
    },
    calcDistance (p1, p2) {
      let R = 6378137; // Earth’s mean radius in meter
      let dLat = this.rad(p2.lat - p1.lat);
      let dLong = this.rad(p2.lng - p1.lng);
      let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.rad(p1.lat)) * Math.cos(this.rad(p2.lat)) *
        Math.sin(dLong / 2) * Math.sin(dLong / 2);
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return (R * c) / 1000;
    },
    rad (x) {
      return x * Math.PI / 180;
    },

    getDirection () {
      let directionsDisplay = new google.maps.DirectionsRenderer();
      let directionsService = new google.maps.DirectionsService();
      directionsDisplay.setMap(this.$refs.map.$mapObject);

      function calculateAndDisplayRoute (directionsService, directionsDisplay, start, destination) {
        directionsService.route({
          origin: start,
          destination: destination,
          travelMode: 'DRIVING'
        }, function (response, status) {
          if (status === 'OK') {
            directionsDisplay.setDirections(response);
          } else {
            errorToast('Не вдалось прокласти оптимальний шлях. Можливо вибрані локації ' +
                                'не зв\'язані із жодним транспортним сполученням');
          }
        });
      }

      calculateAndDisplayRoute(directionsService, directionsDisplay,
        this.location_from, this.getCoordinates());
    }
  }
};
</script>

<style scoped>

</style>
